/*
 * Queens Play — PDP JS.
 *  - Variant selector: color/size buttons write into hidden name="id" input (B-001 fix).
 *  - Gallery thumb click swaps the main image (skips if data-full missing — no pixelated fallback).
 *  - Size guide modal: focus trap + return-focus + Esc close (a11y).
 *  - ATC submit -> window.qpAddToCart optimistic (drawer opens instantly).
 *    Double-submit guard prevents mobile double-taps from firing twice.
 */
(function () {
  'use strict';

  var form = document.querySelector('[data-qp-product-form]');
  if (!form) return;

  var productDataEl = document.querySelector('[data-qp-product-data]');
  var product = null;
  if (productDataEl) {
    try { product = JSON.parse(productDataEl.textContent); }
    catch (e) { product = null; }
  }
  if (!product) return;

  var idInput  = form.querySelector('input[name="id"]');
  var priceEl  = form.querySelector('[data-qp-price]');
  var priceRegEl = form.querySelector('[data-qp-price-reg]');
  var atcBtn   = form.querySelector('[data-qp-atc]');
  var scarcityEl = form.querySelector('[data-qp-scarcity]');
  var colorLabel = form.querySelector('[data-qp-color-label]');
  var sizeLabel  = form.querySelector('[data-qp-size-label]');
  var colorBtns = Array.from(form.querySelectorAll('[data-qp-color-btn]'));
  var sizeBtns  = Array.from(form.querySelectorAll('[data-qp-size-btn]'));

  var optionKeys = product.options || [];
  var atcInFlight = false;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function findVariant(selected) {
    return (product.variants || []).find(function (v) {
      return optionKeys.every(function (name, idx) {
        var want = selected[name.toLowerCase()];
        var have = v.options[idx];
        return want == null || want === have;
      });
    });
  }
  function currentSelection() {
    var sel = {};
    var colorBtn = colorBtns.find(function (b) { return b.classList.contains('is-selected'); });
    var sizeBtn  = sizeBtns.find(function (b) { return b.classList.contains('is-selected'); });
    if (colorBtn) sel.color = colorBtn.getAttribute('data-value');
    if (sizeBtn)  sel.size  = sizeBtn.getAttribute('data-value');
    return sel;
  }

  function updateVariant() {
    var sel = currentSelection();
    var variant = findVariant(sel);
    if (!variant) return;

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (priceRegEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceRegEl.textContent = money(variant.compare_at_price);
        priceRegEl.style.display = '';
      } else {
        priceRegEl.style.display = 'none';
      }
    }
    if (colorLabel && sel.color) colorLabel.textContent = sel.color;
    if (sizeLabel && sel.size)   sizeLabel.textContent  = sel.size;

    if (atcBtn && !atcInFlight) {
      if (!variant.available) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'SOLD OUT';
      } else {
        atcBtn.disabled = false;
        atcBtn.textContent = 'ADD TO BAG · ' + money(variant.price);
      }
    }

    sizeBtns.forEach(function (btn) {
      var sizeVal = btn.getAttribute('data-value');
      var check = { color: sel.color, size: sizeVal };
      var v = findVariant(check);
      if (v && !v.available) {
        btn.classList.add('is-soldout');
        btn.setAttribute('disabled', '');
      } else {
        btn.classList.remove('is-soldout');
        btn.removeAttribute('disabled');
      }
    });

    if (scarcityEl && variant.inventory_quantity != null && variant.inventory_quantity > 0 && variant.inventory_quantity <= 20) {
      scarcityEl.textContent = variant.inventory_quantity + ' left in this size';
      scarcityEl.style.display = '';
    } else if (scarcityEl) {
      scarcityEl.style.display = 'none';
    }
  }

  // ---- form clicks (color / size / gallery — no size-guide here; that's global) ----
  form.addEventListener('click', function (e) {
    var colorBtn = e.target.closest('[data-qp-color-btn]');
    if (colorBtn && !colorBtn.disabled) {
      e.preventDefault();
      colorBtns.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      colorBtn.classList.add('is-selected');
      colorBtn.setAttribute('aria-pressed', 'true');
      updateVariant();
      return;
    }
    var sizeBtn = e.target.closest('[data-qp-size-btn]:not(.is-soldout):not([disabled])');
    if (sizeBtn) {
      e.preventDefault();
      sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      sizeBtn.classList.add('is-selected');
      updateVariant();
      return;
    }
  });

  // Gallery preload — warm the browser cache with every full-size image at
  // page load so the click-to-swap paints instantly. Cheap (4 images per
  // product) and the URLs are the same 1200-wide variants the swap uses,
  // so the cache hit is guaranteed. Runs once, guarded by _qpPreloaded.
  (function preloadGallery() {
    if (window._qpPreloaded) return;
    window._qpPreloaded = true;
    document.querySelectorAll('[data-qp-gallery-thumb]').forEach(function (t) {
      var full = t.getAttribute('data-full');
      if (!full) return;
      var img = new Image();
      img.src = full;
    });
  })();

  // Gallery thumb swap — global (thumbs live outside the form).
  // Skip the swap if no data-full (never fall back to the tiny thumb src).
  // Shopify's image_tag filter emits both srcset + sizes; once srcset is set,
  // the browser picks its URL from there regardless of a new src. Strip both
  // so the swap actually paints. Also nuke srcset FIRST so there's no window
  // where a matching srcset + new src cause a double-fetch flash.
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-qp-gallery-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var full = thumb.getAttribute('data-full');
    if (!full) return;
    document.querySelectorAll('[data-qp-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    var main = document.querySelector('[data-qp-gallery-main] img');
    if (!main) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = full;
  });

  // ---- size guide modal ----
  var sgLastOpener = null;
  function openSizeGuide(trigger) {
    var modal = document.querySelector('[data-qp-sg-modal]');
    if (!modal) return;
    sgLastOpener = trigger || document.activeElement || null;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      var closeBtn = modal.querySelector('[data-qp-sg-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
  }
  function closeSizeGuide() {
    var modal = document.querySelector('[data-qp-sg-modal].is-open');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    if (sgLastOpener && typeof sgLastOpener.focus === 'function') {
      sgLastOpener.focus();
    }
    sgLastOpener = null;
  }
  function trapFocus(modal, e) {
    var focusables = modal.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-qp-sg-open]');
    if (opener) {
      e.preventDefault();
      openSizeGuide(opener);
      return;
    }
    if (e.target.closest('[data-qp-sg-close]') || e.target.matches('[data-qp-sg-modal]')) {
      e.preventDefault();
      closeSizeGuide();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSizeGuide();
    if (e.key === 'Tab') {
      var modal = document.querySelector('[data-qp-sg-modal].is-open');
      if (modal) trapFocus(modal, e);
    }
  });

  // ---- ATC submit → optimistic. Drawer opens instantly with the line in it.
  //      Double-submit guard: nothing else blocks mobile double-taps.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (atcInFlight) return;
    if (!idInput || !idInput.value) return;
    var variantId = parseInt(idInput.value, 10);
    if (!variantId) return;
    var variant = findVariant(currentSelection());
    if (!variant) return;
    atcInFlight = true;
    if (window.qpAddToCart) {
      window.qpAddToCart({
        variantId: variantId,
        variant: variant,
        product: product
      })
        .catch(function () { /* toast already fired */ })
        .then(function () { atcInFlight = false; updateVariant(); });
    } else {
      atcInFlight = false;
      form.submit();
    }
  });

  updateVariant();
})();
